/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import styled from 'styled-components';


import Modal, { ModalHeader, ModalFooter } from '../../../../components/Modal';
import Button from '../../../../components/Button';

import styles from '../../../../styles';



const Text = styled.div`
  padding: 2rem;
  ${styles.fonts.base};
  color: ${styles.colors.biscay};
`;


class DeleteInstanceSubscriptionModal extends React.Component {

  submit = () => {
    this.props.requests.deleteSubscription.handleRequest({
      body: { type: this.props.isProduct ? 'PRODUCT' : 'INSTANCE', instanceKey: this.props.instanceSubscription[0].instanceKey } })
    .then(() => {
      this.props.requests.subscriber.handleRequest();
      this.props.onClose('success', 'Your subscription has been successfully removed from the list.');
    })
    .catch((error) => {
      this.props.requests.subscriber.handleRequest();
      this.props.onClose('failure', 'There was an error. Please try again');
    });
  }

  render() {
    return (
      <Modal onClose={this.props.onClose}>
        <ModalHeader text='Delete Subscription' />
        <Text>
          {`Are you sure you want to delete the subscription for ${this.props.instanceSubscription[0].instanceKey || this.props.instanceSubscription.productKey}?`}
        </Text>
        <ModalFooter>
          <Button onClick={this.props.onClose}>Cancel</Button>
          <Button theme='brand' onClick={this.submit}>Delete</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default DeleteInstanceSubscriptionModal;
